import React from 'react';
import './CardLayoutSettings.css';

export const CardLayoutSettings = ({ onClose, settings, onUpdateSettings }) => {
  const { cardSize = 'medium', fontSize = 'medium', cardStyle = 'default' } = settings;

  const handleCardSizeChange = (size) => {
    onUpdateSettings({ ...settings, cardSize: size });
  };

  const handleFontSizeChange = (size) => {
    onUpdateSettings({ ...settings, fontSize: size });
  };

  const handleCardStyleChange = (style) => {
    onUpdateSettings({ ...settings, cardStyle: style });
  };

  return (
    <div className="card-layout-overlay" onClick={onClose}>
      <div className="card-layout-modal" onClick={(e) => e.stopPropagation()}>
        <div className="card-layout-header">
          <h2>Card Layout Settings</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="card-layout-content">
          {/* Card Size */}
          <div className="setting-section">
            <h3>Card Size</h3>
            <p className="setting-description">Adjust the overall size of flashcards</p>
            <div className="button-group">
              <button
                className={`setting-btn ${cardSize === 'small' ? 'active' : ''}`}
                onClick={() => handleCardSizeChange('small')}
              >
                Small
              </button>
              <button
                className={`setting-btn ${cardSize === 'medium' ? 'active' : ''}`}
                onClick={() => handleCardSizeChange('medium')}
              >
                Medium
              </button>
              <button
                className={`setting-btn ${cardSize === 'large' ? 'active' : ''}`}
                onClick={() => handleCardSizeChange('large')}
              >
                Large
              </button>
            </div>
          </div>

          {/* Font Size */}
          <div className="setting-section">
            <h3>Font Size</h3>
            <p className="setting-description">Adjust the text size on cards</p>
            <div className="button-group">
              <button
                className={`setting-btn ${fontSize === 'small' ? 'active' : ''}`}
                onClick={() => handleFontSizeChange('small')}
              >
                Small
              </button>
              <button
                className={`setting-btn ${fontSize === 'medium' ? 'active' : ''}`}
                onClick={() => handleFontSizeChange('medium')}
              >
                Medium
              </button>
              <button
                className={`setting-btn ${fontSize === 'large' ? 'active' : ''}`}
                onClick={() => handleFontSizeChange('large')}
              >
                Large
              </button>
              <button
                className={`setting-btn ${fontSize === 'extra-large' ? 'active' : ''}`}
                onClick={() => handleFontSizeChange('extra-large')}
              >
                Extra Large
              </button>
            </div>
          </div>

          {/* Card Style */}
          <div className="setting-section">
            <h3>Card Style</h3>
            <p className="setting-description">Choose a visual style for your cards</p>
            <div className="style-grid">
              <div
                className={`style-card ${cardStyle === 'default' ? 'active' : ''}`}
                onClick={() => handleCardStyleChange('default')}
              >
                <div className="style-preview default-preview">
                  <div className="preview-text">Aa</div>
                </div>
                <div className="style-name">Default</div>
              </div>

              <div
                className={`style-card ${cardStyle === 'minimal' ? 'active' : ''}`}
                onClick={() => handleCardStyleChange('minimal')}
              >
                <div className="style-preview minimal-preview">
                  <div className="preview-text">Aa</div>
                </div>
                <div className="style-name">Minimal</div>
              </div>

              <div
                className={`style-card ${cardStyle === 'bold' ? 'active' : ''}`}
                onClick={() => handleCardStyleChange('bold')}
              >
                <div className="style-preview bold-preview">
                  <div className="preview-text">Aa</div>
                </div>
                <div className="style-name">Bold</div>
              </div>

              <div
                className={`style-card ${cardStyle === 'rounded' ? 'active' : ''}`}
                onClick={() => handleCardStyleChange('rounded')}
              >
                <div className="style-preview rounded-preview">
                  <div className="preview-text">Aa</div>
                </div>
                <div className="style-name">Rounded</div>
              </div>
            </div>
          </div>

          {/* Preview */}
          <div className="setting-section">
            <h3>Preview</h3>
            <div className={`preview-container card-size-${cardSize} font-size-${fontSize} card-style-${cardStyle}`}>
              <div className="preview-card">
                <div className="preview-card-header">
                  <span>ENGLISH</span>
                </div>
                <div className="preview-card-content">
                  <div className="preview-card-text">Hello</div>
                  <div className="preview-card-translation">مرحبا</div>
                </div>
              </div>
            </div>
          </div>

          <div className="card-layout-info">
            <p>💡 These settings apply to all study modes (flashcard, quiz, typing)</p>
          </div>
        </div>
      </div>
    </div>
  );
};
